import { Box, Typography } from "@mui/material";
import React from "react";
import { usePagesTranslation } from "../../locales";

/**
 * Footer copyright (same copy as landing; respects UI language).
 */
const CopyrightLine = () => {
    const { t } = usePagesTranslation();
    return (
        <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #e0e0e0', width: '100%', textAlign: 'center' }}>
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem', display: "block" }}>
                {t("landing.copyright")}
            </Typography>
        </Box>
    );
};

export default CopyrightLine;
